import { render, staticRenderFns } from "./ibs-widget.vue?vue&type=template&id=e9083df4"
import script from "./ibs-widget.vue?vue&type=script&lang=js"
export * from "./ibs-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports